module.exports = __webpack_public_path__ + "img/ai1.1b8a40f8.png";